import React, { Component } from "react";
import MySelect from "../../../../../../components/CheckboxSelect";
import {
  postTiktokVerificationAction,
  postTiktokCampaignAction,
  postTiktokCampaignSyncAction,
  postTiktokCampaignReSyncAction,
  deleteAccountsAction,
  getTiktokRedirectUrlAction,
} from "../../../../../../actions";
import { connect } from "react-redux";
import ReactSelect2 from "../../../../../../components/ReactSelect";
import ReactSelect from "react-select";
import _, { isEmpty, get, isEqual } from "lodash";
import ToastModal from "../../../../../../components/ToastModal";
import routes from "../../../../../../routes";
import { withRouter } from "react-router-dom";
import Input from "../../../../../../components/FormElements/Input";
import { tiktokAdsFields } from "./constant";
import { handleFieldError } from "../../../../../../utils/form-validation";

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tiktokAds: [
        {
          optionSelected: [],
          status: false,
          accountsToSet: false,
          accountsList: [],
          accToggle: false,
          campaignToggle: false,
          fetchAccount: [],
          accountDisabled: false,
          campaignDetailsList: {},
          campaignSelected: [],
          sync: false,
          tiktokAdvertiserID: "",
          tiktokCurrency: "",
          accountSelected: {},
          accountEmail: "",
          errors: { tiktokEmail: {} },
          touched: { tiktokEmail: false },
          isInfomo:0
        },
      ],
      accToggle: false,
      campaignToggle: false,
      accountsList: [],
      accountIds: [],
      fetchAccount: [],
      accountSelected: [],
      accountDisabled: false,
      res: [],
      handleApplyClicked: false,
      fieldError: "",
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      isReloadPage: false,
      accountIdForDelete: -1,
      indexForDelete: -1,
      redirectToList: false,
    };
  }

  async componentWillMount() {
    const { paths, syncId, editId } = this.props;
    const { history, match } = paths;

    if (editId) {
      if (
        window.location.href !=
          `${window.location.origin}/atd/admin/advertiser-list/edit-advertiser` &&
        localStorage.getItem("isTikTokLogin")
      ) {
        localStorage.setItem("url", JSON.stringify(window.location.href));
        if (localStorage.getItem("url")) {
          history.push(`${match.path}`);
        }
      }
    } else {
      if (
        window.location.href !=
        `${window.location.origin}/atd/admin/advertiser-list/add-advertiser`
      ) {
        localStorage.setItem("url", JSON.stringify(window.location.href));
        if (localStorage.getItem("url")) {
          history.push(`${match.path}`);
        }
      }
    }

    setTimeout(() => {
      let url = JSON.parse(localStorage.getItem("url"));
      if (
        url &&
        !url.includes("api_auth_cancel") &&
        url.includes("your_custom_params")
      ) {
        localStorage.removeItem("isTikTokLogin");
        this.handleVerification(url);
      } else if (
        url &&
        url.includes("api_auth_cancel") &&
        localStorage.getItem("isTikTokLogin")
      ) {
        localStorage.removeItem("isTikTokLogin");
        localStorage.removeItem("url");
      } else if (localStorage.getItem("isTikTokLogin")) {
        localStorage.removeItem("isTikTokLogin");
        localStorage.removeItem("url");
      }
    }, 1000);

    // if (syncId) {
    //   this.handleCampaigns(0);
    // }

    if (editId) {
      this.editId();
    }
  }

  // ====== will receive props for check the validation of selet box ======
  componentWillReceiveProps(nextProps) {
    const { fieldError } = this.state;
    let nextField = get(nextProps, "checkFields");

    if (!isEqual(fieldError, nextField)) {
      this.setState({ handleApplyClicked: true });
    }

    this.setState({ fieldError: nextField });
  }

  handleChangeEmail = (e, index) => {
    const { tiktokAds } = this.state;
    const { value } = e.target;
    tiktokAds[index].accountEmail = value;
    this.setState({ tiktokAds });
  };

  handleBlurEmail = (e, index) => {
    const { tiktokAds } = this.state;
    const { value } = e.target;
    let clonedTikTokData = _.cloneDeep(tiktokAds[index]);
    let { error, isValid } = handleFieldError(
      clonedTikTokData.accountEmail,
      tiktokAdsFields.tiktokEmail
    );
    tiktokAds[index]["errors"]["tiktokEmail"] = error;
    tiktokAds[index]["touched"]["tiktokEmail"] = true;
    this.setState({ tiktokAds });
  };

  // =========== get tiktok file url =============
  handleGenerateUrl = async (index) => {
    const { tenantId, authToken, userId, getTiktokRedirectUrlAction } =
      this.props;
    const { tiktokAds } = this.state;

    let clonedTikTokData = _.cloneDeep(tiktokAds[index]);

    let { error, isValid } = handleFieldError(
      clonedTikTokData.accountEmail,
      tiktokAdsFields.tiktokEmail
    );

    if (!isValid) {
      tiktokAds[index]["errors"]["tiktokEmail"] = error;
      tiktokAds[index]["touched"]["tiktokEmail"] = true;
      this.setState({ tiktokAds });
    } else {
      localStorage.setItem("loginClicked", JSON.stringify(true));
      localStorage.setItem("isTikTokLogin", true);

      // // dummy

      // let tmpUrl =
      //   "http://localhost:3000/atd/admin/advertiser-list/edit-advertiser?auth_code=1604c1c2730d085404693e9b6544d9bf87940ecb&code=1604c1c2730d085404693e9b6544d9bf87940ecb&state=your_custom_params";
      // tiktokAds.forEach((item,indexAds) => {
      //   if(indexAds == index){
      //   item.status = true;
      //   }
      // });

      // localStorage.setItem("tiktokAds", JSON.stringify(tiktokAds));

      // this.handleVerification(tmpUrl)

      // //dummy

      const {
        responseCode: { status = "", message = "", msg = "" },
        response = "",
      } = await getTiktokRedirectUrlAction({ tenantId, authToken, userId });

      if (status == "Success") {
        const url = response;
        if (url.length > 0) {
          tiktokAds.forEach((item, indexAds) => {
            if (indexAds == index) {
              item.status = true;
              item.accountsToSet = true;
            }
          });
          localStorage.setItem("tiktokAds", JSON.stringify(tiktokAds));
          window.location.href = url;
        } else {
          this.setState({
            enableToast: true,
            confirmationMsg: "URL fetch failed",
            toastMsg: "",
            toastStatus: "required",
          });
        }
      } else {
        this.setState({
          enableToast: true,
          confirmationMsg:
            msg.length > 0
              ? msg
              : message.length > 0
              ? message
              : "Something went wrong",
          toastMsg: "",
          toastStatus: "required",
        });
      }
    }
  };

  // ======== tiktok verification ========
  handleVerification = async (url) => {
    const { tiktokAds } = this.state;
    // const splitUrl = url.split("auth_code=");
    const newObjUrl = new URL(url);
    const urlParams = new URLSearchParams(newObjUrl.search);
    const auth_code = urlParams.get("auth_code");

    let emailAdvertiser = "";
    let selectedTikTokAdsData = JSON.parse(localStorage.getItem("tiktokAds"));
    selectedTikTokAdsData.forEach((item) => {
      if (item.accountsList.length === 0 && item.accountsToSet) {
        emailAdvertiser = item.accountEmail;
      }
    });

    const {
      postTiktokVerificationAction,
      advId = -1,
      tenantId,
      authToken,
      userId,
      tiktokEditData = [],
    } = this.props;

    let params = {
      authCode: auth_code,
      email: emailAdvertiser,
    };

    const {
      responseCode: { status = "", msg = "", message = "" },
      response,
    } = await postTiktokVerificationAction({
      tenantId,
      authToken,
      userId,
      params,
    });

    if (
      status == "Success" &&
      response &&
      response.adAccounts &&
      response.adAccounts.length > 0
    ) {
      localStorage.removeItem("url");
      const accountLists = response.adAccounts.map((data) => {
        let obj = {
          ...data,
          value: data.id,
          label: data.name,
          accountId: data.id,
          email: response.email,
          accessToken: response.accessToken,
          currencyCode: data.currency,
          isExist: data.isExist,
        };
        let findAlreadyExistData = tiktokEditData.find(
          (dataExist) => dataExist.accountId == data.id
        );
        if (findAlreadyExistData) {
          obj["isDisabled"] = true;
        }
        return obj;
      });

      this.setState({ accountsList: accountLists }, () => {
        this.selectedValue();
      });
    } else {
      localStorage.removeItem("url");
      // localStorage.removeItem("advertiserPlatform");
      localStorage.removeItem("loginClicked");
      this.setState({
        enableToast: true,
        confirmationMsg:
          msg.length > 0
            ? msg
            : message.length > 0
            ? message
            : "Something went wrong",
        toastMsg: "",
        toastStatus: "required",
      });
    }
  };

  selectedValue = () => {
    const { accountsList, tiktokAds } = this.state;
    let selectedTikTokAdsData = JSON.parse(localStorage.getItem("tiktokAds"));

    selectedTikTokAdsData.forEach((item) => {
      if (item.accountsList.length === 0 && item.accountsToSet) {
        item.accToggle = true;
        item.accountsList = accountsList;
      }
    });

    this.setState({
      tiktokAds: selectedTikTokAdsData,
      accountsList: accountsList,
    });
  };

  // ========== remove tiktok account ========
  handleRemoveClick = async (index, accountId) => {
    this.setState({
      isReloadPage: true,
      enableToast: true,
      accountIdForDelete: accountId,
      indexForDelete: index,
      toastStatus: "confirmation",
      confirmationMsg: "Kindly confirm the deletion of this record. This action cannot be undone.",
    });
  };

  handleCloseBtn = async (index) => {
    const { tiktokAds } = this.state;
    const list = [...tiktokAds];
    list.splice(index, 1);
    this.setState({ tiktokAds: list });
  };

  // ========== add new tiktok account ========
  handleAddClick = () => {
    this.setState(
      {
        tiktokAds: [
          ...this.state.tiktokAds,
          {
            optionSelected: [],
            status: false,
            accountsList: [],
            accToggle: false,
            accountsToSet: false,
            campaignToggle: false,
            fetchAccount: [],
            accountDisabled: false,
            campaignSelected: [],
            sync: false,
            tiktokAdvertiserID: "",
            tiktokCurrency: "",
            accountEmail: "",
            accountSelected: {},
            errors: { tiktokEmail: {} },
            touched: { tiktokEmail: false },
            isInfomo:0
          },
        ],
      },
      () => {}
    );
  };

  handleResync = async (tiktokList, index) => {
    const { tiktokAds } = this.state;
    const {
      postTiktokCampaignReSyncAction,
      advId = -1,
      tenantId,
      authToken,
      userId,
    } = this.props;

    if (
      tiktokList &&
      tiktokList.tiktokAdvertiserID &&
      tiktokList.tiktokAdvertiserID.toString().length > 0
    ) {
      const {
        responseCode: { status = "", msg = "", message = "" },
        response,
      } = await postTiktokCampaignReSyncAction({
        tenantId,
        authToken,
        userId,
        accountId: tiktokList.tiktokAdvertiserID,
      });

      if (
        status == "Success" &&
        response.accountCampaignList &&
        response.accountCampaignList.length > 0
      ) {
        let fetchedData = response.accountCampaignList[0].campaignList.map(
          (camp) => {
            return {
              label: camp.campaign_name,
              value: camp.campaign_name,
              name: camp.campaign_name,
              ...camp,
            };
          }
        );

        let obj = {
          currencyCode: tiktokAds[index].accountSelected.currencyCode,
          isNew: 0,
          refreshToken: tiktokAds[index].accountSelected.refreshToken,
          email: tiktokAds[index].accountSelected.email,
          campaignDetails: fetchedData,
        };

        tiktokAds[index].campaignToggle = true;
        tiktokAds[index].campaigns = obj;
        tiktokAds[index].campaignSelected = fetchedData.filter(
          (dataFilter) => dataFilter.isexist == 1
        );
        this.setState({ tiktokAds });
      } else {
        this.setState({
          enableToast: true,
          confirmationMsg:
            msg.length > 0
              ? msg
              : message.length > 0
              ? message
              : "Something went wrong",
          toastMsg: "",
          toastStatus: "required",
        });
      }
    } else {
      this.setState({
        enableToast: true,
        confirmationMsg: "Please Select A Account.",
        toastMsg: "",
        toastStatus: "required",
      });
    }
  };

  editId = () => {
    const { tiktokEditData = [], editId } = this.props;
    const { tiktokAds } = this.state;

    if (editId) {
      let tiktokAdsData = tiktokEditData.map((item) => {
        return {
          tiktokAdvertiserID: item.accountId,
          tiktokCurrency: item.currency,
          optionSelected: [],
          status: false,
          accountsList: [],
          accountsToSet: false,
          accToggle: false,
          campaignToggle: false,
          fetchAccount: [],
          accountDisabled: false,
          campaignDetailsList: {},
          campaignSelected: [],
          sync: true,
          accountEmail: "",
          accountSelected: {},
          errors: { tiktokEmail: {} },
          touched: { tiktokEmail: false },
          isInfomo:item.isInfomo == 1 ? 1 : 0,
          accountName:item.accountName ? item.accountName : ""
        };
      });

      this.setState({ tiktokAds: tiktokAdsData });
    } else {
      this.setState({ tiktokAds });
    }
  };

  handleAction = (event, index) => {
    const { id } = event.target;
    if (id == "account-list") {
      this.handleCampaigns(index);
    } else {
      this.setState({ campaignToggle: false });
    }
  };

  handleCampaigns = async (index) => {
    const { fetchAccount, accountSelected, tiktokAds } = this.state;
    const {
      postTiktokCampaignAction,
      loginStatus,
      syncId,
      tenantId,
      authToken,
      userId,
      advId,
    } = this.props;
    let clonedData = _.cloneDeep(tiktokAds[index]);

    if (Object.keys(clonedData.accountSelected).length > 0) {
      let payload = {
        email: clonedData.accountSelected.email,
        accessToken: clonedData.accountSelected.accessToken,
        adAccounts: [clonedData.accountSelected],
      };
      const {
        responseCode: { status = "", msg = "", message = "" },
        response,
      } = await postTiktokCampaignAction({
        tenantId,
        authToken,
        userId,
        payload,
      });
      if (status == "Success") {
        this.setState({ res: response });
        if (
          response &&
          response.accountCampaignList &&
          response.accountCampaignList.length > 0
        ) {
          let res = response.accountCampaignList[0].campaignList.map((camp) => {
            return {
              label: camp.campaign_name,
              value: camp.campaign_name,
              name: camp.campaign_name,
              ...camp,
            };
          });

          let obj = {
            currencyCode: tiktokAds[index].accountSelected.currencyCode,
            isNew: 0,
            refreshToken: tiktokAds[index].accountSelected.refreshToken,
            email: tiktokAds[index].accountSelected.email,
            campaignDetails: res,
          };
          // if (!loginStatus) {
          tiktokAds[index].campaignToggle = true;
          tiktokAds[index].accountDisabled = true;
          // }

          tiktokAds[index].campaignDetailsList = obj;

          this.setState({ tiktokAds });
        } else {
          this.setState({
            enableToast: true,
            confirmationMsg: "No campaign found",
            toastMsg: "",
            toastStatus: "required",
          });
        }
      } else {
        this.setState({
          enableToast: true,
          confirmationMsg:
            msg.length > 0
              ? msg
              : message.length > 0
              ? message
              : "Something went wrong",
          toastMsg: "",
          toastStatus: "required",
        });
      }
    } else {
      this.setState({
        enableToast: true,
        confirmationMsg: "Please Select A Account.",
        toastMsg: "",
        toastStatus: "required",
      });
    }
  };

  // ========== sync campaign =======
  handleSyncCampaign = async (index) => {
    const { tiktokAds } = this.state;

    const {
      postTiktokCampaignSyncAction,
      tenantId,
      advId = -1,
      authToken,
      userId,
    } = this.props;

    let clonedTikTokData = _.cloneDeep(tiktokAds[index]);

    if (
      clonedTikTokData &&
      clonedTikTokData.campaignSelected &&
      clonedTikTokData.campaignSelected.length > 0
    ) {
      let payload = {
        accountCampaignList: [
          {
            accountId: clonedTikTokData.tiktokAdvertiserID,
            campaignList: clonedTikTokData.campaignSelected,
          },
        ],
      };

      const {
        responseCode: { status = "", msg = "", message = "" },
      } = await postTiktokCampaignSyncAction({
        tenantId,
        authToken,
        userId,
        payload,
      });
      if (status == "Success") {
        this.setState({
          enableToast: true,
          toastStatus: status,
          toastMsg:
            msg.length > 0
              ? msg
              : message.length > 0
              ? message
              : "Campaign sync successfully",
          redirectToList: true,
        });
      } else {
        this.setState({
          enableToast: true,
          confirmationMsg:
            msg.length > 0
              ? msg
              : message.length > 0
              ? message
              : "Something went wrong",
          toastMsg: "",
          toastStatus: "required",
        });
      }
    } else {
      let toastStatus = "required";
      let msg = "Please select a campaign.";
      this.setState({
        enableToast: true,
        toastStatus: toastStatus,
        toastMsg: msg,
      });
      // this.setState({ enableToast: true, confirmationMsg: "Please Select A Campaign.", toastMsg: "", toastStatus: "required" });
    }
  };

  handleSelectChange = (selected, index, name, campaignDetails) => {
    if (name === "accounts") {
      let accounts = [];
      selected.isMasterNew = 0;
      selected.isNew = 0;

      let obj = {
        customerId: selected.customerId,
        masterId: selected.masterId,
        currencyCode: selected.currencyCode,
        isNew: selected.isNew,
        isMasterNew: selected.isMasterNew,
        refreshToken: selected.refreshToken,
        email: selected.email,
      };
      accounts.push(obj);

      const { tiktokAds } = this.state;
      tiktokAds[index].accountSelected = selected;
      tiktokAds[index].tiktokAdvertiserID = selected.accountId;
      tiktokAds[index].tiktokCurrency = selected.currencyCode;
      this.setState({
        tiktokAds,
        accountSelected: accounts,
        handleApplyClicked: false,
      });
    } else if (name === "campaigns") {
      const { tiktokAds } = this.state;
      tiktokAds[index].campaignSelected = selected;
      this.setState({ tiktokAds });
    }
  };

  deleteRecord = async () => {
    const { tenantId, authToken, userId, deleteAccountsAction } = this.props;
    const { accountIdForDelete, indexForDelete } = this.state;
    const {
      responseCode: { status = "", msg = "" },
      responseList,
    } = await deleteAccountsAction({
      tenantId,
      authToken,
      userId,
      accountId: accountIdForDelete,
    });
    if (status == "Success") {
      const { tiktokAds } = this.state;
      const list = [...tiktokAds];
      list.splice(indexForDelete, 1);
      this.setState({ tiktokAds: list });
      window.location.reload();
    } else if (status.toLowerCase() == "fail") {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : "Something went wrong";
      this.setState({
        enableToast: true,
        toastStatus: toastStatus,
        toastMsg: msgStr,
      });
    }
  };

  confirmationCallbackModel = (id) => {
    const { isReloadPage } = this.state;
    this.setState({ enableToast: false }, () => {
      if (isReloadPage) {
        this.deleteRecord();
      }
    });
  };

  handleToastStatus = (status) => {
    const { redirectToList } = this.state;
    const {
      match: { params: id },
      history,
    } = this.props;
    this.setState({ enableToast: false }, () => {
      if (redirectToList) {
        history.push(
          "/" +
            routes.mainRoute +
            "/" +
            routes.containers.admin +
            "/" +
            routes.admin.advertiser.newAdvertiser
        );
      }
    });
  };

  render() {
    const { options, paths } = this.props;
    const {
      campaignDetails,
      tiktokAds,
      handleApplyClicked,
      enableToast,
      toastStatus,
      toastMsg,
      confirmationMsg,
    } = this.state;
    let Option = options.optionFun;
    let multiValue = options.multiValue;

    // console.log(tiktokAds);
    return (
      <>
        {enableToast && (
          <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + "/" + routes.admin.advertiser.poc}
            idProps={paths}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
            poc={true}
          />
        )}
        <div className={`col-md-8 offset-md-2`}>
          {tiktokAds.map((tiktokList, index) =>
            !tiktokList.sync ? (
              tiktokList.status ? (
                <div
                  className={`mb-4 mainCard ${
                    tiktokList.status ? "text-left" : ""
                  }`}
                  key={index}
                >
                  <p>Login With Tiktok Account : {index + 1}</p>
                  <div className="col-md-11">
                    {tiktokList.accToggle ? (
                      <>
                        <h5>Account List :</h5>
                        <div className="platform">
                          <div className="selectBox">
                            <ReactSelect2
                              options={tiktokList.accountsList}
                              onChange={(selected) =>
                                this.handleSelectChange(
                                  selected,
                                  index,
                                  "accounts"
                                )
                              }
                              defaultValue={tiktokList.accountSelected}
                              value={tiktokList.accountSelected}
                              className="selectBox"
                              disabled={tiktokList.accountDisabled}
                              errors={
                                handleApplyClicked
                                  ? _.isEmpty(tiktokList.accountSelected)
                                    ? true
                                    : false
                                  : false
                              }
                            />
                          </div>
                          {!tiktokList.campaignToggle && (
                            <div className="syncCampagin text-right">
                              <button
                                className="btn-add"
                                id="account-list"
                                autoFocus={true}
                                onClick={(e) => this.handleAction(e, index)}
                              >
                                Sync
                              </button>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {tiktokList.campaignToggle ? (
                      <>
                        <div className="removeML pointerEventNone mt-2">
                          <Input
                            onChange={() => {}}
                            onBlur={() => {}}
                            value={tiktokList.tiktokCurrency}
                            setting={
                              tiktokAdsFields[
                                tiktokAdsFields.tiktokCurrency.key
                              ]
                            }
                          />
                        </div>

                        <h5 className="mt-2">Sync Campaign :</h5>
                        <div className="platform">
                          <div className="selectBox">
                            <MySelect
                              options={
                                tiktokList.campaignDetailsList.campaignDetails
                              }
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              components={{ Option, multiValue }}
                              onChange={(selected) =>
                                this.handleSelectChange(
                                  selected,
                                  index,
                                  "campaigns",
                                  campaignDetails
                                )
                              }
                              allowSelectAll={true}
                              value={tiktokList.campaignSelected}
                            />
                          </div>

                          <div className="syncCampagin text-right">
                            <button
                              className="btn-add"
                              onClick={() => this.handleSyncCampaign(index)}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div className="loginBtnList mt-3 mb-3">
                  <p>Login With Tiktok Account : {index + 1}</p>

                  <Input
                    onChange={(e) => {
                      this.handleChangeEmail(e, index);
                    }}
                    onBlur={(e) => {
                      this.handleBlurEmail(e, index);
                    }}
                    value={tiktokList.accountEmail}
                    setting={tiktokAdsFields[tiktokAdsFields.tiktokEmail.key]}
                    error={tiktokList.errors[tiktokAdsFields.tiktokEmail.key]}
                    // submited={submited}
                    touched={
                      tiktokList.touched[tiktokAdsFields.tiktokEmail.key]
                    }
                  />

                  <button
                    key={index}
                    className="loginBtn loginBtn--tiktok"
                    onClick={() => this.handleGenerateUrl(index)}
                  >
                    Login with TikTok
                  </button>

                  <button
                    className="btn-delete"
                    onClick={() => this.handleCloseBtn(index)}
                  >
                    <i className="mdi mdi-close"></i>
                  </button>
                </div>
              )
            ) : (
              <>
                {tiktokList.isInfomo == 0 ? (
                  <div className="col-md-12 mb-4 manualCard" key={index}>
                    <h5 className="text-dark">Tiktok Account {index + 1} :</h5>

                    <div className="pointerEventNone">
                      <Input
                        onChange={() => {}}
                        onBlur={() => {}}
                        value={`${tiktokList.accountName ? tiktokList.accountName +" "+'(' + tiktokList.tiktokAdvertiserID + ')' : tiktokList.tiktokAdvertiserID}`}
                        setting={
                          tiktokAdsFields[
                            tiktokAdsFields.tiktokAdvertiserID.key
                          ]
                        }
                      />
                    </div>

                    <div className="removeML pointerEventNone">
                      <Input
                        onChange={() => {}}
                        onBlur={() => {}}
                        value={tiktokList.tiktokCurrency}
                        setting={
                          tiktokAdsFields[tiktokAdsFields.tiktokCurrency.key]
                        }
                      />
                    </div>

                    {tiktokList.campaignToggle ? (
                      <div className="">
                        <h5>Sync Campaign :</h5>
                        <div className="platform col-md-12 p-0">
                          <MySelect
                            options={tiktokList.campaigns.campaignDetails}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{ Option, multiValue }}
                            onChange={(selected) =>
                              this.handleSelectChange(
                                selected,
                                index,
                                "campaigns"
                              )
                            }
                            allowSelectAll={true}
                            value={tiktokList.campaignSelected}
                            className="selectBox"
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="btn-manual text-right mt-2">
                      <button
                        className="btn-remove"
                        onClick={() =>
                          this.handleRemoveClick(
                            index,
                            tiktokList.tiktokAdvertiserID
                          )
                        }
                        style={{ top: "40px" }}
                      >
                        <i className="mdi mdi-delete"></i>
                      </button>

                      {!tiktokList.campaignToggle ? (
                        <button
                          onClick={() => this.handleResync(tiktokList, index)}
                          className="btnSync ml-2"
                        >
                          <i className="mdi mdi-sync"></i>
                        </button>
                      ) : (
                        <button
                          className="btn-add ml-2"
                          onClick={() => this.handleSyncCampaign(index)}
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="col-md-12 mb-4 manualCard" key={index}>
                    <h5 className="text-dark">TikTok Account {index + 1} :</h5>
                    <div>
                      <h5>Infomo Seat</h5>
                    </div>
                    <div className="btn-manual text-right mt-2">
                      <button
                        className="btn-remove"
                        onClick={() =>
                          this.handleRemoveClick(
                            index,
                            tiktokList.tiktokAdvertiserID
                          )
                        }
                        style={{ top: "40px" }}
                      >
                        <i className="mdi mdi-delete"></i>
                      </button>
                    </div>
                  </div>
                )}
              </>
            )
          )}
        </div>

        <div className="addBtn" style={{ textAlign: "right" }}>
          <button
            className="btn-add-io"
            style={{ marginTop: "0px", float: "none" }}
            onClick={() => this.handleAddClick()}
          >
            <i className="mdi mdi-plus-box"></i>
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      configurationList: get(state, "app.configurationData.responseList", []),
      tenantId: get(state, "app.preSignInState.tenantId", ""),
      userId: get(state, "app.preSignInData.userId", ""),
      authToken: get(state, "app.signInData.authToken", ""),
    }),
    {
      postTiktokVerificationAction,
      postTiktokCampaignAction,
      postTiktokCampaignSyncAction,
      postTiktokCampaignReSyncAction,
      deleteAccountsAction,
      getTiktokRedirectUrlAction,
    }
  )(index)
);
